import { render, staticRenderFns } from "./StationWaterQualityChart.vue?vue&type=template&id=27f510fb"
import script from "./StationWaterQualityChart.vue?vue&type=script&lang=js"
export * from "./StationWaterQualityChart.vue?vue&type=script&lang=js"
import style0 from "./StationWaterQualityChart.vue?vue&type=style&index=0&id=27f510fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports